export const CREATORS_PAGE_KEY = "creators_client";

// Keep in sync with web_admin/src/views/pages/PageBuilder/sectionSchemas.js.
// Empty fonts mean "keep the site fonts", so nothing changes until an admin picks one.
export const DEFAULT_CREATORS_LAYOUT = {
  theme: {
    headingFont: "",
    bodyFont: "",
    primaryColor: "#FF7F26",
  },
  sections: [
    {
      id: "hero",
      type: "creatorsHero",
      visible: true,
      style: {},
      props: {
        heading: "KUVUMA Creators ready to serve you. Select your expert and assign a task",
        subtext:
          "Browse our network of skilled professionals. Search by name or filter by skill, service, experience, location and budget to find the perfect match for your project.",
        hireForMeButton: "Hire for me",
      },
    },
    {
      // The rate currency is appended to the budget label in code.
      id: "filters",
      type: "creatorsFilters",
      visible: true,
      style: {},
      props: {
        searchPlaceholder: "Search by name, skill, service, location, rate or budget",
        skillLabel: "Skill",
        serviceLabel: "Service",
        experienceLabel: "Experience",
        providerTypeLabel: "Provider type",
        locationLabel: "Location",
        rateTypeLabel: "Rate type",
        budgetLabel: "Max budget",
      },
    },
    {
      id: "results",
      type: "creatorsResults",
      visible: true,
      style: {},
      props: {
        viewButton: "View",
        hireButton: "Hire Creator",
        emptyTitle: "No service provider available",
        emptyText: "There are no service providers available at the moment.",
      },
    },
  ],
};
